<template>
  <div
    class="reports-sidebar-button"
    :class="{
      selected: selected === item,
      disabled: !this.isSuperAdmin && item.disabled
    }"
    @click="toggle"
  >
    {{ item.name }}
    <dev-tag v-if="item.dev" position="relative" style="margin-left: 15px" />
  </div>
</template>

<script>
import DevTag from "@/components/_Atoms/DevTag";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  components: { DevTag },

  props: ["item", "selected"],

  mixins: [checkPermissionsMixin],

  methods: {
    toggle() {
      this.$emit("toggle", this.item);
    }
  }
};
</script>

<style scoped>
.reports-sidebar-button {
  color: #23292e;
  padding: 8px 30px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.reports-sidebar-button:hover,
.reports-sidebar-button.selected {
  background: rgba(79, 162, 183, 0.4);
}

.reports-sidebar-button.selected {
  font-weight: bold;
}
.reports-sidebar-button.disabled {
  pointer-events: none;
  cursor: inherit;
  color: #b7b7b7;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/Sidebar/ReportsSidebarButton.vue